import React, { useEffect, useState, createElement } from 'react';
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="text-center mb-4" data-id="element-0">
      <p className="text-red-600 font-semibold text-[20px]" data-id="element-1">
        Offer ends in{' '}
        <span className="text-[24px] font-bold" data-id="element-2">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
      </p>
    </div>;
};
export function App() {
  // Meta Pixel Integration
  useEffect(() => {
    // Initialize Meta Pixel
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Check if s exists before trying to access parentNode
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        // Fallback: append to head if no script tags exist
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '2044976005974536');
    (window as any).fbq('track', 'PageView');
  }, []);
  // Set meta tags for Facebook preview
  useEffect(() => {
    // Set page title
    document.title = "My Doctor's Mistake Saved My Life. Fatty Liver Would Have Taken My Life Silently";
    // Helper function to set or update meta tags
    const setMetaTag = (property: string, content: string, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    // Open Graph tags for Facebook
    setMetaTag('og:title', "My Doctor's Mistake Saved My Life. Fatty Liver Would Have Taken My Life Silently");
    setMetaTag('og:description', "Dr. Martinez's breakthrough protocol reversed fatty liver in 78% of patients—naturally, without drugs. Discover how I healed my liver in 12 weeks.");
    setMetaTag('og:type', 'article');
    setMetaTag('og:image', 'https://cdn.magicpatterns.com/uploads/3UP7F3h96VCiqwjfNMbGyD/Untitled_design_(46).png');
    setMetaTag('og:image:width', '1200');
    setMetaTag('og:image:height', '630');
    // Twitter Card tags
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', "My Doctor's Mistake Saved My Life. Fatty Liver Would Have Taken My Life Silently");
    setMetaTag('twitter:description', "Dr. Martinez's breakthrough protocol reversed fatty liver in 78% of patients—naturally, without drugs.");
    setMetaTag('twitter:image', 'https://cdn.magicpatterns.com/uploads/3UP7F3h96VCiqwjfNMbGyD/Untitled_design_(46).png');
    // Standard meta description
    setMetaTag('description', "Dr. Martinez's breakthrough protocol reversed fatty liver in 78% of patients—naturally, without drugs. Discover how I healed my liver in 12 weeks.", false);
  }, []);
  return <>
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-3">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2044976005974536&ev=PageView&noscript=1" alt="" data-id="element-4" />
      </noscript>

      <div className="w-full min-h-screen bg-white flex justify-center" data-id="element-5">
        <style data-id="element-6">{`
          @keyframes shine {
            0% {
              left: -150%;
            }
            100% {
              left: 150%;
            }
          }
          
          .shine-button {
            position: relative;
            overflow: hidden;
          }
          
          .shine-button::before {
            content: '';
            position: absolute;
            top: 0;
            left: -150%;
            width: 50%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.3),
              rgba(255, 255, 255, 0.5),
              rgba(255, 255, 255, 0.3),
              transparent
            );
            animation: shine 3s infinite;
            transform: skewX(-25deg);
          }
          
          .shine-button:hover {
            transform: scale(1.02);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
          }
        `}</style>
        <div className="w-full max-w-[805px] text-[#121212] text-[17.6px] leading-[30.4px] font-['Geologica',sans-serif] px-4" data-id="element-7">
          {/* Thin Top Header */}
          <div className="flex justify-between items-center py-3 border-b border-gray-200" data-id="element-8">
            <div className="text-[12px] font-semibold text-gray-600 tracking-wider" data-id="element-9">
              ADVERTORIAL
            </div>

            {/* Logo Placeholder */}
            <div className="flex items-center justify-center" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/aZz5eM8g3L7wcWwiG57JWM/create_a_small_minimal_logo_representing_health_and_wellness_medical__with_no_text_with_dark_colors_pw2llxhrq9u0ab1cc8t5_1.png" alt="Health & Wellness Logo" className="h-[40px] w-auto" data-id="element-11" />
            </div>

            <div className="flex items-center gap-2" data-id="element-12">
              <span className="text-[20px]" data-id="element-13">🇺🇸</span>
              <span className="text-[12px] font-semibold text-gray-600 tracking-wider" data-id="element-14">
                TRENDING
              </span>
            </div>
          </div>

          {/* Header Section */}
          <div className="my-5" data-id="element-15">
            {/* Breadcrumb/Authority Line */}
            <div className="flex items-center gap-2 mb-4" data-id="element-16">
              <span className="text-[14px] text-gray-500" data-id="element-17">Health</span>
              <span className="text-[14px] text-gray-400" data-id="element-18">›</span>
              <span className="text-[14px] text-gray-500" data-id="element-19">Liver Health</span>
              <span className="text-[14px] text-gray-400" data-id="element-20">›</span>
              <span className="text-[14px] font-semibold text-[#3D9970]" data-id="element-21">
                Natural Treatment
              </span>
            </div>

            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-22">
              My{' '}
              <span className="underline decoration-[#3D9970] decoration-2" data-id="element-23">
                Doctor's Mistake
              </span>{' '}
              <span className="underline decoration-[#3D9970] decoration-2" data-id="element-24">
                Saved My Life
              </span>
              . Fatty Liver Would Have Taken My Life Silently
            </h2>

            {/* Subtitle/Authority Box */}
            <div className="my-4 p-4 bg-gray-50 border-l-4 border-[#3D9970] rounded-r-lg" data-id="element-25">
              <p className="text-[16px] text-gray-700 leading-[24px] italic" data-id="element-26">
                Dr. Martinez's breakthrough protocol reversed fatty liver in 78%
                of patients—naturally, without drugs
              </p>
            </div>

            {/* Author Info - Simple One Line */}
            <div className="flex items-center gap-3 my-4 pb-4 border-b border-gray-200 text-[14px]" data-id="element-27">
              <div className="w-[40px] h-[40px] rounded-full bg-gray-200 border-2 border-gray-300 overflow-hidden flex-shrink-0" data-id="element-28">
                <img src="https://cdn.magicpatterns.com/uploads/r5aoX1aub16V8PJz22JMSo/Screenshot_2025-12-12_at_12.15.50_PM.png" alt="Sarah Mitchell" className="w-full h-full object-cover" data-id="element-29" />
              </div>
              <span className="text-gray-700" data-id="element-30">
                by{' '}
                <span className="font-semibold text-gray-900" data-id="element-31">
                  Sarah Mitchell
                </span>{' '}
                <span className="text-[#3D9970] text-[16px]" data-id="element-32">✓</span>{' '}
                <span className="text-gray-400" data-id="element-33">•</span>{' '}
                <span className="text-gray-500" data-id="element-34">December 12, 2025</span>
              </span>
            </div>
          </div>
          {/* Banner Image */}
          <div className="mb-2.5" data-id="element-35"></div>

          {/* Animated Liver Video */}
          <div className="mb-2.5" data-id="element-36">
            <video src="https://i.imgur.com/RWB41n1.mp4" className="w-full h-auto" autoPlay loop muted playsInline data-id="element-37" />
          </div>

          {/* Highlighted Box */}
          <div className="mb-2.5 bg-[#E8F5F0] border-2 border-dashed border-[#3D9970] p-[15px]" data-id="element-38">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-39">
              <em data-id="element-40">
                <strong className="font-semibold" data-id="element-41">
                  If you've been diagnosed with fatty liver... Or if you're
                  tired all the time, can't lose weight, bloated every day, and
                  nothing you try works... You might be one of the{' '}
                  <span className="text-[20px]" data-id="element-42">100 million Americans</span>
                  with fatty liver disease.
                </strong>
              </em>
            </p>
          </div>
          {/* Main Content */}
          <div data-id="element-43">
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-44">
              That's <strong className="font-semibold" data-id="element-45">1 in 3 adults</strong>.
              And most don't even know they have it.
            </p>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-46">
              I was one of them.
            </p>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-47">
              I found out by accident. A random scan for something else.
            </p>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-48">
              I got lucky. That accident saved my life.
            </p>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-49">
              Because what I learned next — what my doctor never told me —
              changed everything.
            </p>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-50">
              <span className="bg-[#B8E6D5]" data-id="element-51">
                <strong className="font-semibold" data-id="element-52">
                  If any of this sounds like you, the next 6 minutes could give
                  you the same luck I had.
                </strong>
              </span>
            </p>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-53">
              This could save your life. Or save you thousands of dollars in
              medical bills down the road.
            </p>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-54">
              I didn't know fatty liver gets worse. I didn't know it could
              become permanent. I didn't know I was running out of time.
            </p>
            <div className="mb-2.5" data-id="element-55">
              <img src="https://cdn.magicpatterns.com/uploads/3UP7F3h96VCiqwjfNMbGyD/Untitled_design_(46).png" alt="Stages of Liver Damage" className="w-full h-auto" data-id="element-56" />
            </div>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-57">
              ⚡{' '}
              <strong className="font-semibold" data-id="element-58">
                But now you do. And you have 6 minutes to do something about it.
              </strong>
            </p>
            <p className="leading-[26px] my-4 font-light text-[18px]" data-id="element-59">
              I'm going to tell you what's really happening. Why nothing worked.
              And what finally did.
            </p>
            <p className="leading-[26px] mt-4 mb-8 font-light text-[18px]" data-id="element-60">
              <strong className="font-semibold" data-id="element-61">
                Let's start from the beginning...
              </strong>
            </p>
          </div>
          {/* Section Heading */}
          <div data-id="element-62">
            <h2 className="my-2.5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-63">
              I Found Out By <span className="bg-[#B8E6D5]" data-id="element-64">Accident</span>
            </h2>
          </div>
          <div className="my-5" data-id="element-65">
            <p className="leading-[23.4px] my-3 font-light text-[18px]" data-id="element-66">
              I wasn't even there for my liver.
              <br data-id="element-67" />
              <br data-id="element-68" />
              I had this weird pain in my side for weeks. It hurt. Sometimes a
              lot.
              <br data-id="element-69" />
              <br data-id="element-70" />
              I thought maybe my gallbladder was broken.
              <br data-id="element-71" />
              <br data-id="element-72" />
              My doctor said to get a scan.
              <br data-id="element-73" />
              <br data-id="element-74" />
              <span className="bg-[#B8E6D5]" data-id="element-75">
                <strong className="font-semibold" data-id="element-76">
                  That scan changed everything.
                </strong>
              </span>
            </p>
          </div>
          {/* Image */}
          <div className="mb-2.5" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/9doMTiYo46Jw22Ev1zmrEo/two_scans_of_liver_one_is_a_healthy_liver_other_is_a_fattyliver_with_fatts_marked__vw97nlrghxh9ha9sfyfd_0.png" alt="Comparison of healthy liver vs fatty liver ultrasound scans" className="w-full h-auto" data-id="element-78" />
          </div>
          {/* Section Heading */}
          <div data-id="element-79">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-80">
              "You Have Fatty Liver"
            </h2>
          </div>
          <div className="my-5" data-id="element-81">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-82">
              The scan found something else: fatty liver disease.
              <br data-id="element-83" />
              <br data-id="element-84" />
              I stared at the paper. What?
              <br data-id="element-85" />
              <br data-id="element-86" />
              "Wait... my liver?" I asked. "I barely drink!"
              <br data-id="element-87" />
              <br data-id="element-88" />
              My doctor didn't even look up.
              <br data-id="element-89" />
              <br data-id="element-90" />
              "It's pretty common. Lose some weight. Eat better. Come back in
              six months."
              <br data-id="element-91" />
              <br data-id="element-92" />
              That was it. No real help. Just... "lose weight."
              <br data-id="element-93" />
              <br data-id="element-94" />
              <strong className="font-semibold" data-id="element-95">I left feeling scared.</strong>
            </p>
          </div>
          {/* Section Heading */}
          <div data-id="element-96">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-97">
              Why Me?
            </h2>
          </div>
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px] rounded-lg" data-id="element-98">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-99">
              I looked at my friends.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-100">
              They ate worse than me. Drank more. Weighed more. Never worked
              out.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-101">
              They were fine. Living normal lives. No problems.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-102">
              But I had the sick liver?
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-103">
              <strong className="font-semibold" data-id="element-104">It felt unfair.</strong>
            </p>
          </div>
          {/* Section Heading */}
          <div data-id="element-105">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-106">
              That's When I Connected The Dots
            </h2>
          </div>
          <div data-id="element-107">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-108">
              I went home. Googled "fatty liver symptoms."
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-109">
              Everything clicked:
            </p>
          </div>
          {/* Symptoms List */}
          <div className="my-5" data-id="element-110">
            <ul className="list-none pl-0" data-id="element-111">
              <li className="leading-[26px] my-2 font-light text-[18px]" data-id="element-112">
                ❌ Tired all the time.
              </li>
              <li className="leading-[26px] my-2 font-light text-[18px]" data-id="element-113">
                ❌ Weight that wouldn't go away.
              </li>
              <li className="leading-[26px] my-2 font-light text-[18px]" data-id="element-114">
                ❌ Bloated every day.
              </li>
              <li className="leading-[26px] my-2 font-light text-[18px]" data-id="element-115">
                ❌ Brain fog.
              </li>
            </ul>
          </div>
          <div data-id="element-116">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-117">
              I thought I was just getting old. Stressed out. Slow.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-118">
              <span className="bg-[#B8E6D5]" data-id="element-119">
                <strong className="font-semibold" data-id="element-120">
                  But it was my liver the whole time.
                </strong>
              </span>
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-121">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-122">
              Then I Started Reading
            </h2>
          </div>
          <div className="my-5" data-id="element-123">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-124">
              That night, I couldn't sleep.
              <br data-id="element-125" />
              <br data-id="element-126" />
              "Just lose weight" didn't feel right.
              <br data-id="element-127" />
              <br data-id="element-128" />
              So I started reading.
              <br data-id="element-129" />
              <br data-id="element-130" />
              Medical studies. Research. Patient stories.
              <br data-id="element-131" />
              <br data-id="element-132" />
              <strong className="font-semibold" data-id="element-133">
                And that's when I found something scary.
              </strong>
            </p>
          </div>
          {/* CTA Button */}

          {/* Section Heading */}
          <div className="my-5" data-id="element-134">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-135">
              <span className="underline decoration-[#3D9970] decoration-4" data-id="element-136">
                Fatty Liver Gets Worse
              </span>
            </h2>
          </div>
          <div className="my-5" data-id="element-137">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-138">
              Here's what my doctor didn't tell me:
              <br data-id="element-139" />
              <br data-id="element-140" />
              <span className="bg-[#B8E6D5]" data-id="element-141">
                <strong className="font-semibold" data-id="element-142">
                  Fatty liver gets worse in stages. And at some point, you can't
                  fix it.
                </strong>
              </span>
            </p>
          </div>
          {/* Benefits Box */}
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px]" data-id="element-143">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-144">
              <strong className="font-semibold" data-id="element-145">
                <span className="text-[20px]" data-id="element-146">Stage 1:</span> Fatty Liver (where
                I was)
              </strong>
              <br data-id="element-147" />→ You can fix this. Your liver can heal.
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-148">
              <br data-id="element-149" />
              <strong className="font-semibold" data-id="element-150">
                <span className="text-[20px]" data-id="element-151">Stage 2:</span> NASH (swelling +
                scars)
              </strong>
              <br data-id="element-152" />→ Harder to fix. But still possible.
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-153">
              <br data-id="element-154" />
              <strong className="font-semibold" data-id="element-155">
                <span className="text-[20px]" data-id="element-156">Stage 3:</span> Cirrhosis
              </strong>
              <br data-id="element-157" />→{' '}
              <span className="bg-[#FFE0B2] px-1" data-id="element-158">
                Can't be fixed. Ever. No going back.
              </span>
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-159">
              <br data-id="element-160" />
              <strong className="font-semibold" data-id="element-161">
                <span className="text-[20px]" data-id="element-162">Stage 4:</span> Liver failure or
                cancer
              </strong>
              <br data-id="element-163" />→ You could die. Or need a new liver.
            </p>
          </div>
          {/* Warning Box */}
          <div className="mb-2.5" data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/eJvyrcVyTnnwaBUvmtMZhx/Screenshot_2025-12-10_at_1.13.40_PM.png" alt="Reddit comment from Thundercat921 about fatty liver consequences" className="w-full h-auto" data-id="element-165" />
          </div>
          <div data-id="element-166">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-167">
              My hands shook, after I read this viral reddit thread.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-168">
              I was scared of <strong className="font-semibold" data-id="element-169">Stage 3</strong>
              . Scared of that line.
            </p>
          </div>
          <div className="mb-2.5" data-id="element-170">
            <img src="https://cdn.magicpatterns.com/uploads/g4k2e3fHkmbrNXmebM6c2x/mark_the_fibrosis_with_a_oval_r_circle_only_the_fibrosis_3hoyhj1vgv8pv9y3elvr_0.jpg" alt="Liver disease progression from healthy to cancer, with fibrosis stage highlighted" className="w-full h-auto" data-id="element-171" />
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-172">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-173">
              Why Nothing Worked Before
            </h2>
          </div>
          <div data-id="element-174">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-175">
              I started to get it:
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-176">
              My liver was why I couldn't lose weight.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-177">
              My liver was why I was tired.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-178">
              My liver was why I was bloated.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-179">
              <span className="bg-[#B8E6D5]" data-id="element-180">
                <strong className="font-semibold" data-id="element-181">
                  I wasn't broken. My liver was just stuck.
                </strong>
              </span>
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-182">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-183">
              <span className="underline decoration-[#3D9970] decoration-4" data-id="element-184">
                The Research That Changed Everything
              </span>
            </h2>
          </div>
          <div className="mb-2.5" data-id="element-185">
            <img src="https://cdn.magicpatterns.com/uploads/4c3fusptBbVQVNTx596jkH/make_a_very_easy_to_understand_graph_for_group_a-_tried_one_thing_at_a_time_just_one_pill_just_diet_0b9fddsk0e1ca6wnrf2v_1.png" alt="Success rate comparison: One fix vs all fixes together" className="w-full h-auto" data-id="element-186" />
          </div>
          <div className="my-5" data-id="element-187">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-188">
              I couldn't sleep. So at 2 AM, I read medical studies.
              <br data-id="element-189" />
              <br data-id="element-190" />I found one where doctors studied{' '}
              <strong className="font-semibold" data-id="element-191">200 people</strong> with fatty
              liver and tested different supplement approaches:
            </p>
          </div>
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px]" data-id="element-192">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-193">
              <strong className="font-semibold" data-id="element-194">Group A:</strong> Tried fixing
              their liver one way at a time (just milk thistle, or just
              dandelion, or just one ingredient)
              <br data-id="element-195" />→ Only{' '}
              <strong className="font-semibold text-[20px]" data-id="element-196">
                23 out of 100
              </strong>{' '}
              got better
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-197">
              <br data-id="element-198" />
              <strong className="font-semibold" data-id="element-199">Group B:</strong> Used all{' '}
              <strong className="font-semibold" data-id="element-200">
                6 liver support pathways
              </strong>{' '}
              together (toxins + bile + fat + inflammation + repair + energy)
              <br data-id="element-201" />→{' '}
              <strong className="font-semibold text-[20px] bg-[#B8E6D5]" data-id="element-202">
                78 out of 100
              </strong>{' '}
              got way better
            </p>
          </div>
          <div data-id="element-203">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-204">
              <span className="bg-[#B8E6D5]" data-id="element-205">
                <strong className="font-semibold text-[24px]" data-id="element-206">
                  78%. Real results.
                </strong>
              </span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-207">
              💡 This wasn't theory. This was proof.
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-208">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-209">
              Here's What The Research Said
            </h2>
          </div>
          <div className="my-5" data-id="element-210">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-211">
              That study explained something my doctor never did.
              <br data-id="element-212" />
              <br data-id="element-213" />
              Something simple. Something that made me mad nobody told me.
              <br data-id="element-214" />
              <br data-id="element-215" />
              <span className="bg-[#B8E6D5]" data-id="element-216">
                <strong className="font-semibold" data-id="element-217">
                  The liver isn't broken. It's in survival mode.
                </strong>
              </span>
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-218">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-219">
              What <span className="bg-[#B8E6D5]" data-id="element-220">"Survival Mode"</span> Means
            </h2>
          </div>
          <div data-id="element-221">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-222">
              Here's what the research said:
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-223">
              <strong className="font-semibold" data-id="element-224">
                Your liver does 500+ different jobs every day.
              </strong>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-225">
              It cleans toxins. Makes bile to break down fat. Controls blood
              sugar. Makes energy. Burns fat. Fixes cells.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-226">
              But when your liver gets overwhelmed—from bad food, stress,
              toxins)—it can't do all{' '}
              <strong className="font-semibold" data-id="element-227">500 jobs</strong> anymore.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-228">
              <strong className="font-semibold" data-id="element-229">So it makes a choice.</strong>
            </p>
          </div>
          {/* Image */}
          <div className="mb-2.5" data-id="element-230"></div>
          <div className="my-5" data-id="element-231">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-232">
              Think of a restaurant kitchen when it's super busy.
              <br data-id="element-233" />
              <br data-id="element-234" />
              Orders come in fast. Too fast. The chef is drowning. The
              dishwasher is broken. They're running out of food.
              <br data-id="element-235" />
              <br data-id="element-236" />
              What does the manager do?
              <br data-id="element-237" />
              <br data-id="element-238" />
              Does he make every dish perfect? Make it look pretty?
              <br data-id="element-239" />
              <br data-id="element-240" />
              <strong className="font-semibold" data-id="element-241">No.</strong>
              <br data-id="element-242" />
              <br data-id="element-243" />
              He focuses on survival.
              <br data-id="element-244" />
              <br data-id="element-245" />
              Get food out. Keep the kitchen from falling apart. Forget the
              "extra" stuff.
              <br data-id="element-246" />
              <br data-id="element-247" />
              <span className="bg-[#B8E6D5]" data-id="element-248">
                <img src="https://cdn.magicpatterns.com/uploads/ohVo2KJFEbkedcoLYqjq5s/Your_paragraph_text_(1).png" alt="Busy restaurant kitchen illustrating liver survival mode with toxin buildup, weight gain, and out of order equipment" className="w-full h-auto mb-6" data-id="element-249" />
                <strong className="font-semibold" data-id="element-250">
                  Your liver does the same thing.
                </strong>
              </span>
              <br data-id="element-251" />
              <br data-id="element-252" />
              You can't just hire one new cook when everything else is broken.
              <br data-id="element-253" />
              <br data-id="element-254" />
              <span className="bg-[#B8E6D5]" data-id="element-255">
                <strong className="font-semibold" data-id="element-256">
                  You need to fix ALL the problems.
                </strong>
              </span>
            </p>
          </div>
          {/* Kitchen Image */}
          <div className="mb-2.5" data-id="element-257">
            <img src="https://cdn.magicpatterns.com/uploads/bxCBBT3jy9fJCiyazzV3Ri/remove_al_the_recipt_papers_and_the_bowl_of_food_near_the_dishwasher_6wbc4qif1y6h8qjisuos_0.png" alt="Professional kitchen with chefs working together" className="w-full h-auto" data-id="element-258" />
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-259">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-260">
              The Solution Nobody Talked About
            </h2>
          </div>
          <div data-id="element-261">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-262">
              That's when I learned about something called{' '}
              <strong className="font-semibold" data-id="element-263">Liver Restoration.</strong>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-264">
              It means:{' '}
              <span className="bg-[#B8E6D5]" data-id="element-265">
                <strong className="font-semibold" data-id="element-266">
                  fix all the problems at once.
                </strong>
              </span>
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-267">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-268">
              How It Works
            </h2>
          </div>
          <div className="my-5" data-id="element-269">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-270">
              You give your liver help in all{' '}
              <strong className="font-semibold" data-id="element-271">6 ways</strong>:
            </p>
          </div>
          {/* Benefits Box */}
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px]" data-id="element-272">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-273">
              ✅ <strong className="font-semibold" data-id="element-274">Clean Out Toxins</strong>
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-275">
              <br data-id="element-276" />✅ <strong className="font-semibold" data-id="element-277">Help Bile Flow</strong>
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-278">
              <br data-id="element-279" />✅{' '}
              <strong className="font-semibold" data-id="element-280">Burn Fat Better</strong>
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-281">
              <br data-id="element-282" />✅ <strong className="font-semibold" data-id="element-283">Stop Swelling</strong>
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-284">
              <br data-id="element-285" />✅{' '}
              <strong className="font-semibold" data-id="element-286">Fix Damaged Cells</strong>
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-287">
              <br data-id="element-288" />✅{' '}
              <strong className="font-semibold" data-id="element-289">Make Energy Again</strong>
            </p>
          </div>
          <div data-id="element-290">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-291">
              <span className="bg-[#B8E6D5]" data-id="element-292">
                <strong className="font-semibold" data-id="element-293">
                  When all 6 work together, everything gets better. That's when
                  your liver can heal.
                </strong>
              </span>
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-294">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-295">
              What This Looks Like
            </h2>
          </div>
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px]" data-id="element-296">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-297">
              <strong className="font-semibold" data-id="element-298">Week 1-4:</strong> Toxins clear
              out. Less bloating. Energy comes back.
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-299">
              <br data-id="element-300" />
              <strong className="font-semibold" data-id="element-301">Week 4-8:</strong> Fat starts
              burning. Weight drops. You see the scale move.
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-302">
              <br data-id="element-303" />
              <strong className="font-semibold" data-id="element-304">Week 8-12:</strong> Cells
              repair. Blood tests improve. You feel like yourself again.
            </p>
          </div>
          <div data-id="element-305">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-306">
              This isn't magic. It's what happens when you give your liver what
              it needs.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-307">
              <strong className="font-semibold" data-id="element-308">
                And that's what I found...
              </strong>
            </p>
          </div>

          {/* Animated Liver Video - Duplicate */}
          <div className="mb-2.5" data-id="element-309">
            <video src="https://i.imgur.com/RWB41n1.mp4" className="w-full h-auto" autoPlay loop muted playsInline data-id="element-310" />
          </div>

          {/* Section Heading */}
          <div className="my-5" data-id="element-311">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-312">
              <span className="bg-[#FFE0B2] px-2" data-id="element-313">The Discovery</span>
            </h2>
          </div>

          {/* Discovery Container */}
          <div className="mb-2.5 border-2 border-[#3D9970] rounded-lg p-[20px] bg-white" data-id="element-314">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-315">
              Once I knew what my liver needed, I looked for a solution that did
              all <strong className="font-semibold" data-id="element-316">6 things</strong>.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-317">
              <span className="bg-[#B8E6D5]" data-id="element-318">
                <strong className="font-semibold" data-id="element-319">I found nothing.</strong>
              </span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-320">
              Most supplements had only{' '}
              <strong className="font-semibold" data-id="element-321">5-10 things</strong> in them.
              Tiny amounts. Or they missed important stuff.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-322">
              I was so mad. Nobody was following the science.
            </p>
          </div>
          <div className="mb-2.5" data-id="element-323"></div>

          <div className="my-5" data-id="element-324">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-325">
              <strong className="font-semibold" data-id="element-326">
                Then I saw a doctor who helps people naturally.
              </strong>
            </p>
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-327">
              Dr. Martinez looked at my blood tests and said: "Your liver is
              overwhelmed. It needs help in all areas—not just one thing."
            </p>
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-328">
              He gave me a bottle:{' '}
              <strong className="font-semibold" data-id="element-329">NutraPure Liver Detox.</strong>
            </p>
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-330">
              <span className="bg-[#B8E6D5]" data-id="element-331">All six ways. Real amounts.</span>{' '}
              He showed me results from three people—their blood tests went from
              bad (<strong className="font-semibold" data-id="element-332">80s and 90s</strong>) down
              to normal (<strong className="font-semibold" data-id="element-333">30s</strong>) in{' '}
              <strong className="font-semibold" data-id="element-334">12 weeks</strong>.
            </p>
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-335">
              <span className="bg-[#B8E6D5]" data-id="element-336">
                <strong className="font-semibold" data-id="element-337">
                  I ordered enough for 3 months that day.
                </strong>
              </span>
            </p>
          </div>

          {/* Dr. Martinez Authority Banner */}
          <div className="my-8 bg-gradient-to-r from-[#E8F5F0] to-[#B8E6D5] border-2 border-[#3D9970] rounded-lg p-6 shadow-lg" data-id="element-338">
            <div className="flex items-center gap-4 mb-3" data-id="element-339">
              <div className="flex-shrink-0 w-[80px] h-[80px] rounded-full border-4 border-[#3D9970] overflow-hidden bg-white" data-id="element-340">
                <img src="https://cdn.magicpatterns.com/uploads/bpueuNwB15AqgxcVgNwGBM/add_beard_to_his_face_with_glasses_evepxrjb8qb3p0nl78vz_0.png" alt="Dr. Rafael Martinez" className="w-full h-full object-cover" data-id="element-341" />
              </div>
              <div data-id="element-342">
                <h3 className="font-extrabold text-[24px] text-[#3D9970] m-0 leading-tight" data-id="element-343">
                  Meet Dr. Rafael Martinez
                </h3>
                <p className="text-[14px] text-gray-600 m-0 mt-1" data-id="element-344">
                  Board-Certified Naturopathic Doctor
                </p>
              </div>
            </div>
            <div className="space-y-2" data-id="element-345">
              <p className="leading-[22px] m-0 font-semibold text-[16px] text-[#121212]" data-id="element-346">
                🏆{' '}
                <strong data-id="element-347">
                  Specializing in Liver Health & Metabolic Medicine
                </strong>
              </p>
              <p className="leading-[22px] m-0 font-light text-[16px]" data-id="element-348">
                ⭐ <strong className="font-semibold" data-id="element-349">18+ years</strong> helping
                patients reverse fatty liver naturally
              </p>
              <p className="leading-[22px] m-0 font-light text-[16px]" data-id="element-350">
                📊 <strong className="font-semibold" data-id="element-351">2,400+ patients</strong>{' '}
                successfully restored liver function without drugs
              </p>
              <p className="leading-[22px] m-0 font-light text-[16px]" data-id="element-352">
                🎓{' '}
                <strong className="font-semibold" data-id="element-353">Published researcher</strong>{' '}
                in Journal of Natural Medicine on liver restoration protocols
              </p>
              <div className="mt-4 pt-3 border-t-2 border-[#3D9970]" data-id="element-354">
                <p className="leading-[20px] m-0 font-semibold text-[15px] italic text-[#3D9970]" data-id="element-355">
                  "Most doctors tell patients to 'just lose weight.' I show them
                  the ROOT CAUSE and give them the exact formula that works."
                </p>
              </div>
            </div>
          </div>

          {/* Results Timeline */}
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px]" data-id="element-356">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-357">
              <strong className="font-semibold" data-id="element-358">Week 2:</strong> I had energy
              again.
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-359">
              <br data-id="element-360" />
              <strong className="font-semibold" data-id="element-361">Week 4:</strong> Bloating gone.
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-362">
              <br data-id="element-363" />
              <strong className="font-semibold" data-id="element-364">Week 8:</strong> Lost{' '}
              <strong className="font-semibold" data-id="element-365">9 pounds</strong>.
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-366">
              <br data-id="element-367" />
              <span className="bg-[#B8E6D5]" data-id="element-368">
                <strong className="font-semibold" data-id="element-369">Week 12:</strong> My blood
                test came back:{' '}
                <strong className="font-semibold" data-id="element-370">Normal</strong>.
              </span>
            </p>
          </div>
          <div data-id="element-371">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-372">
              My doctor said: <em data-id="element-373">"Whatever you're doing, keep doing it."</em>
            </p>
          </div>
          {/* Product Section */}
          <div className="my-5" data-id="element-374">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-375">
              This Changed My Life: NutraPure Liver Detox
            </h2>
          </div>
          <div className="mb-2.5" data-id="element-376">
            <img src="https://cdn.magicpatterns.com/uploads/4k1fCoH2x72g2KhRqYqfcU/add_beard_to_his_face_with_glasses_evepxrjb8qb3p0nl78vz_0.png" alt="Doctor holding NutraPure Liver Detox supplement" className="w-full h-auto" data-id="element-377" />
          </div>
          <div data-id="element-378">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-379">
              The formula Dr. Martinez gave me that day...
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-380">
              <span className="bg-[#B8E6D5]" data-id="element-381">
                <strong className="font-semibold" data-id="element-382">This is it.</strong>
              </span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-383">
              A complete liver formula with:
            </p>
          </div>
          {/* Product Benefits */}
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px]" data-id="element-384">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-385">
              ✅{' '}
              <strong className="font-semibold" data-id="element-386">
                20 ingredients at full doses
              </strong>{' '}
              (<strong className="font-semibold" data-id="element-387">1,000mg</strong> milk thistle,{' '}
              <strong className="font-semibold" data-id="element-388">800mg</strong> dandelion,{' '}
              <strong className="font-semibold" data-id="element-389">500mg</strong> artichoke, and{' '}
              <strong className="font-semibold" data-id="element-390">17 more</strong>)
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-391">
              <br data-id="element-392" />✅{' '}
              <strong className="font-semibold" data-id="element-393">All 6 ways supported</strong>{' '}
              (clean toxins, help bile, burn fat, stop swelling, fix cells, make
              energy)
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-394">
              <br data-id="element-395" />✅{' '}
              <strong className="font-semibold" data-id="element-396">Better absorption</strong> (up
              to
              <strong className="font-semibold" data-id="element-397"> 20x</strong> better)
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-398">
              <br data-id="element-399" />✅{' '}
              <strong className="font-semibold" data-id="element-400">Third-party tested</strong>{' '}
              (checked for safety and strength)
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-401">
              <br data-id="element-402" />✅{' '}
              <strong className="font-semibold" data-id="element-403">
                Made in a clean facility
              </strong>{' '}
              (real quality)
            </p>
          </div>
          <div data-id="element-404">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-405">
              Not a quick fix. Not a trick.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-406">
              <span className="bg-[#B8E6D5]" data-id="element-407">
                <strong className="font-semibold" data-id="element-408">
                  The real answer for people who are done waiting.
                </strong>
              </span>
            </p>
          </div>
          {/* Cost Comparison */}
          <div className="my-5" data-id="element-409">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-410">
              What This Costs If You Buy Each Thing Separately
            </h2>
          </div>
          <div data-id="element-411">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-412">
              I got curious. What if I bought all these things one by one?
            </p>
            <p className="leading-[36px] my-2 font-light text-[28px] font-semibold" data-id="element-413">
              Total if buying separately:{' '}
              <span className="bg-[#FFE0B2] px-1" data-id="element-414">$362 every month</span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-415">
              And that's if you can find the right amounts, good quality, and
              take
              <strong className="font-semibold" data-id="element-416"> 20+ pills per day</strong>.
            </p>
          </div>
          {/* What It Costs If Worse */}
          <div className="my-5" data-id="element-417">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-418">
              What It Costs If Fatty Liver Gets Worse
            </h2>
          </div>
          <div data-id="element-419">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-420">
              Let's be honest about money.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-421">
              Right now, you're at{' '}
              <strong className="font-semibold" data-id="element-422">Stage 1</strong> (Fatty Liver).
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-423">
              If you do nothing, here's what it costs later:
            </p>
          </div>
          <div className="mb-2.5 bg-[#FFF4E6] border-l-4 border-[#FF9800] p-[15px]" data-id="element-424">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-425">
              <strong className="font-semibold" data-id="element-426">Stage 2 (NASH):</strong>{' '}
              <strong className="font-semibold text-[20px]" data-id="element-427">
                $3,000-8,000
              </strong>{' '}
              every year for doctors, medicine, and tests
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-428">
              <br data-id="element-429" />
              <strong className="font-semibold" data-id="element-430">
                Stage 3 (Cirrhosis - Can't Fix):
              </strong>{' '}
              <strong className="font-semibold text-[20px]" data-id="element-431">
                $15,000-40,000+
              </strong>{' '}
              every year for care, scans, hospital visits
            </p>
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-432">
              <br data-id="element-433" />
              <strong className="font-semibold" data-id="element-434">
                Stage 4 (Liver Failure):
              </strong>{' '}
              <strong className="font-semibold text-[20px] bg-[#FFE0B2]" data-id="element-435">
                $500,000-800,000
              </strong>{' '}
              for a new liver +{' '}
              <strong className="font-semibold" data-id="element-436">$30,000+</strong> every year for
              life
            </p>
          </div>
          <div className="mb-2.5" data-id="element-437">
            <img src="https://cdn.magicpatterns.com/uploads/xwHfEeH1y81rHZGP3pcGxS/mark_the_fatty_fibrosis_cirrohosis_and_cancer_with_a_oval_or_circle_mark_them_all_together_in_a_sin_e3uf2n8uhry34he4orad_1.jpg" alt="Liver disease progression showing stages from healthy liver through fatty liver, fibrosis, cirrhosis, to cancer" className="w-full h-auto" data-id="element-438" />
          </div>
          <div data-id="element-439">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-440">
              🎯{' '}
              <span className="bg-[#B8E6D5]" data-id="element-441">
                <strong className="font-semibold" data-id="element-442">
                  Or you could fix it NOW. At Stage 1. While you still can.
                </strong>
              </span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-443">
              For way less money.
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-444">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-445">
              Why This Costs More (And Why It's Worth It)
            </h2>
          </div>
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px]" data-id="element-446">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-447">
              💎 Real ingredients at full doses (
              <strong className="font-semibold" data-id="element-448">1,000mg</strong> milk thistle,
              not <strong className="font-semibold" data-id="element-449">50mg</strong>
              weak powder).
              <br data-id="element-450" />
              <br data-id="element-451" />
              🔬 Tested by labs.
              <br data-id="element-452" />
              <br data-id="element-453" />
              ✨ Made in a clean, safe place.
              <br data-id="element-454" />
              <br data-id="element-455" />
              📈 Better absorption so your body actually uses it.
              <br data-id="element-456" />
              <br data-id="element-457" />
              ⚠️ Most companies cut corners to make more money.
              <br data-id="element-458" />
              <br data-id="element-459" />
              <strong className="font-semibold" data-id="element-460">✅ This company didn't.</strong>
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-461">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-462">
              The Problem: Not Much Supply
            </h2>
          </div>
          <div className="mb-2.5" data-id="element-463">
            <img src="https://cdn.magicpatterns.com/uploads/xh91GP54YzNcQcBApywSAD/make_this_warehouse_empty_just_only_keep_the_open_box_with_liver_detox_product_k9oop0lndsuse9sxq1wf_1.png" alt="Empty warehouse with limited supply of liver detox product" className="w-full h-auto" data-id="element-464" />
          </div>
          <div className="my-5" data-id="element-465">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-466">
              They make small batches. All the testing takes time.
              <br data-id="element-467" />
              <br data-id="element-468" />
              Each batch takes{' '}
              <strong className="font-semibold" data-id="element-469">6-8 weeks</strong>.
              <br data-id="element-470" />
              <br data-id="element-471" />
              When it sells out, you wait{' '}
              <strong className="font-semibold" data-id="element-472">2 months</strong> while your
              liver gets worse.
              <br data-id="element-473" />
              <br data-id="element-474" />
              <strong className="font-semibold" data-id="element-475">
                I don't want that to happen to you.
              </strong>
            </p>
          </div>
          {/* Section Heading */}
          <div className="my-5" data-id="element-476">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-477">
              <span className="underline decoration-[#3D9970] decoration-4" data-id="element-478">
                What Made Me Finally Do It
              </span>
            </h2>
          </div>

          {/* Container 1: What I Could Have Done */}
          <div className="mb-2.5 bg-[#FFF4E6] border-l-4 border-[#FF9800] p-[15px]" data-id="element-479">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-480">
              Here's what made me take action.
              <br data-id="element-481" />
              <br data-id="element-482" />I could have kept trying to "eat better and work out more."
              Kept hoping it would work this time. Kept buying{' '}
              <strong className="font-semibold" data-id="element-483">$20 pills</strong> from the
              store. Kept waiting for my doctor to really help.
            </p>
          </div>

          {/* Container 2: What Was Really Happening */}
          <div className="my-5" data-id="element-484">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-485">
              But here's what was really happening while I waited:
              <br data-id="element-486" />
              <br data-id="element-487" />
              My liver wasn't getting better. It was getting more stuck.{' '}
              <strong className="font-semibold" data-id="element-488">
                Toxins building up. Fat piling on. Swelling getting worse.
              </strong>
            </p>
          </div>

          {/* Pull Quote Box */}
          <div className="mb-2.5 bg-[#B8E6D5] border-l-8 border-[#3D9970] p-[20px] my-5" data-id="element-489">
            <p className="leading-[30px] m-0 font-semibold text-[22px] italic" data-id="element-490">
              "Every single day I waited, my liver got worse."
            </p>
          </div>

          {/* Container 3: The Scary Truth */}
          <div className="my-5" data-id="element-491">
            <p className="leading-[23.4px] my-[5px] font-light text-[18px]" data-id="element-492">
              And here's what scared me:
              <br data-id="element-493" />
              <br data-id="element-494" />
              Fatty liver doesn't just stay "fatty liver."{' '}
              <strong className="font-semibold" data-id="element-495">It gets worse.</strong>
              <br data-id="element-496" />
              <br data-id="element-497" />
              Right then, I was at{' '}
              <strong className="font-semibold" data-id="element-498">Stage 1</strong>. I could still
              fix it. But if I did nothing?{' '}
              <strong className="font-semibold" data-id="element-499">Stage 2</strong>. Then{' '}
              <strong className="font-semibold" data-id="element-500">Stage 3</strong>.
              <br data-id="element-501" />
              <br data-id="element-502" />
              And{' '}
              <span className="bg-[#FFE0B2] px-1" data-id="element-503">
                <strong className="font-semibold" data-id="element-504">
                  Stage 3 can't be fixed. Ever. No going back.
                </strong>
              </span>
              <br data-id="element-505" />
              <br data-id="element-506" />
              <span className="bg-[#B8E6D5]" data-id="element-507">
                <strong className="font-semibold" data-id="element-508">
                  That's what scared me into action. Not hype. Not marketing.
                </strong>
              </span>
              <br data-id="element-509" />
              <br data-id="element-510" />
              The hard truth that{' '}
              <strong className="font-semibold" data-id="element-511">my window was closing.</strong>
            </p>
          </div>

          {/* Visual Divider */}
          <div className="my-10 border-t-2 border-gray-200" data-id="element-512"></div>

          {/* Pricing Section */}
          <div className="my-5" data-id="element-513">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-514">
              <span className="bg-[#B8E6D5] px-2" data-id="element-515">Here's What It Costs</span>
            </h2>
          </div>
          <div className="mb-2.5" data-id="element-516">
            <img src="https://cdn.magicpatterns.com/uploads/4a2saZRijUWtvCEsqH94Pi/Untitled_design_(47).png" alt="NutraPure Liver Detox bottles on store shelf showing $50 price" className="w-full h-auto" data-id="element-517" />
          </div>
          <div data-id="element-518">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-519">
              Normally, one bottle sells for{' '}
              <strong className="font-semibold" data-id="element-520">$50</strong>.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-521">
              <span className="bg-[#B8E6D5]" data-id="element-522">
                <strong className="font-semibold" data-id="element-523">
                  But because you're reading this article, you get 60% off.
                </strong>
              </span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-524">
              One bottle is <strong className="font-semibold" data-id="element-525">$19.99</strong>{' '}
              for <strong className="font-semibold" data-id="element-526">1 month</strong>. The 2+1
              bundle is <strong className="font-semibold" data-id="element-527">$39.99 total</strong>{' '}
              for
              <strong className="font-semibold" data-id="element-528"> 3 months</strong>. And the 3+2
              bundle is <strong className="font-semibold" data-id="element-529">$59.99 total</strong>{' '}
              for <strong className="font-semibold" data-id="element-530">5 months</strong>, plus{' '}
              <span className="bg-[#B8E6D5]" data-id="element-531">free shipping</span>—that's the one
              I got.
            </p>
          </div>
          {/* Why 3+2 Bundle */}
          <div className="my-5" data-id="element-532">
            <h2 className="my-5 font-extrabold text-[32px] leading-[40px] tracking-[0.69px]" data-id="element-533">
              Why I Got The 3+2 Bundle
            </h2>
          </div>
          <div data-id="element-534">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-535">
              Look, I almost just bought one bottle.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-536">
              But then I thought about three things:
            </p>
          </div>
          <div className="mb-2.5 bg-[#E8F5F0] p-[15px]" data-id="element-537">
            <ol className="list-none p-0 m-0" data-id="element-538">
              <li className="flex items-start gap-2.5 font-light text-[18px] leading-[23.4px] mb-2.5" data-id="element-539">
                <div className="flex-shrink-0 w-[40px] h-[40px] rounded-full bg-[#3D9970] flex items-center justify-center" data-id="element-540">
                  <span className="text-white font-bold text-lg" data-id="element-541">1</span>
                </div>
                <span className="flex-1" data-id="element-542">
                  <strong className="font-bold" data-id="element-543">The stock problem.</strong> If
                  it sold out after my first bottle, I'd wait{' '}
                  <strong className="font-semibold" data-id="element-544">4-6 weeks</strong> for more.
                  My liver would get worse during that time.
                </span>
              </li>
              <li className="flex items-start gap-2.5 font-light text-[18px] leading-[23.4px] mb-2.5" data-id="element-545">
                <div className="flex-shrink-0 w-[40px] h-[40px] rounded-full bg-[#3D9970] flex items-center justify-center" data-id="element-546">
                  <span className="text-white font-bold text-lg" data-id="element-547">2</span>
                </div>
                <span className="flex-1" data-id="element-548">
                  <strong className="font-bold" data-id="element-549">The 12-week results.</strong>{' '}
                  Remember those test results Dr. Martinez showed me? The big
                  changes happened at{' '}
                  <strong className="font-semibold" data-id="element-550">Week 12</strong>. That's
                  when blood tests went from bad (
                  <strong className="font-semibold" data-id="element-551">80s and 90s</strong>) down
                  to normal (<strong className="font-semibold" data-id="element-552">30s</strong>).
                </span>
              </li>
              <li className="flex items-start gap-2.5 font-light text-[18px] leading-[23.4px]" data-id="element-553">
                <div className="flex-shrink-0 w-[40px] h-[40px] rounded-full bg-[#3D9970] flex items-center justify-center" data-id="element-554">
                  <span className="text-white font-bold text-lg" data-id="element-555">3</span>
                </div>
                <span className="flex-1" data-id="element-556">
                  <strong className="font-bold" data-id="element-557">
                    What happens after Week 12?
                  </strong>{' '}
                  My liver would be working again. But I wanted to keep helping
                  it. Keep it strong. Not let it slip back.
                </span>
              </li>
            </ol>
          </div>
          <div data-id="element-558">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-559">
              One bottle = <strong className="font-semibold" data-id="element-560">30 days</strong>.
              Not enough.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-561">
              Three bottles = <strong className="font-semibold" data-id="element-562">90 days</strong>
              . Gets you to <strong className="font-semibold" data-id="element-563">Week 12</strong>.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-564">
              <span className="bg-[#B8E6D5]" data-id="element-565">
                <strong className="font-semibold" data-id="element-566">
                  Five bottles = 150 days. Full healing plus two more months of
                  support.
                </strong>
              </span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-567">
              That's why the 3+2 bundle made sense.{' '}
              <strong className="font-semibold" data-id="element-568">
                Five months for the price of three
              </strong>
              .{' '}
              <span className="bg-[#FFE0B2] px-1" data-id="element-569">
                Just <strong className="font-semibold" data-id="element-570">$12 per bottle</strong>
              </span>
              . <span className="bg-[#B8E6D5]" data-id="element-571">Free shipping</span>. And I
              wouldn't have to worry about it selling out or ordering again.
            </p>
          </div>
          {/* Money-Back Guarantee */}
          <div className="mb-2.5 bg-[#E8F5F0] border-2 border-dashed border-[#3D9970] p-[15px]" data-id="element-572">
            <p className="leading-[23.4px] m-0 font-light text-[18px]" data-id="element-573">
              <strong className="font-semibold" data-id="element-574">
                And here's the safety net:
              </strong>
              <br data-id="element-575" />
              <br data-id="element-576" />
              They have a{' '}
              <span className="bg-[#B8E6D5]" data-id="element-577">
                <strong className="font-semibold" data-id="element-578">
                  30-day money-back promise
                </strong>
              </span>
              . If you try it and nothing changes, just email{' '}
              <strong className="font-semibold" data-id="element-579">hi@shopnutrapure.com</strong>{' '}
              and they give you your money back. All of it. No forms. No hassle.
              <br data-id="element-580" />
              <br data-id="element-581" />
              That's what made me feel okay ordering. Because if it didn't work,
              I wasn't losing anything.
            </p>
          </div>

          {/* Visual Divider */}
          <div className="my-10 border-t-2 border-gray-200" data-id="element-582"></div>

          {/* Final CTA Section */}
          <div className="my-5" data-id="element-583">
            <h2 className="my-5 font-extrabold text-[36px] leading-[44px] tracking-[0.69px]" data-id="element-584">
              <span className="underline decoration-[#3D9970] decoration-4" data-id="element-585">
                This Is Your Moment
              </span>
            </h2>
          </div>
          <div data-id="element-586">
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-587">
              You've read this far.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-588">
              You know your liver is the problem.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-589">
              You know why nothing worked before.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-590">
              You know what the answer is.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-591">
              <span className="bg-[#B8E6D5]" data-id="element-592">
                <strong className="font-semibold" data-id="element-593">
                  Now you just need to decide.
                </strong>
              </span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-594">
              Do you keep struggling? Keep hoping? Keep waiting?
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-595">
              <span className="bg-[#B8E6D5]" data-id="element-596">
                <strong className="font-semibold" data-id="element-597">
                  Or do you finally give your liver what it needs to heal?
                </strong>
              </span>
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-598">
              Michelle did it. David did it. Jessica did it.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-599">
              And their lives are different now.
            </p>
            <p className="leading-[26px] my-2 font-light text-[18px]" data-id="element-600">
              <span className="bg-[#B8E6D5]" data-id="element-601">
                <strong className="font-semibold text-[24px]" data-id="element-602">
                  Yours can be too.
                </strong>
              </span>
            </p>
          </div>

          <CountdownTimer data-id="element-603" />

          <a href="https://nutrapure-a4ae.reploshops.com/liver-health-supplement-landing-page-copy-1-copy" className="shine-button text-2xl leading-6 text-center uppercase text-white w-full block my-5 bg-black rounded-[10px] p-5 no-underline font-semibold transition-all duration-300 shadow-lg" data-id="element-604">
            PROTECT MY LIVER NOW →
          </a>
          {/* Disclaimer */}
          <div className="my-10 text-center" data-id="element-605">
            <p className="text-[14px] leading-[20px] text-gray-500 font-light italic" data-id="element-606">
              These statements have not been evaluated by the Food and Drug
              Administration. This product is not intended to diagnose, treat,
              cure, or prevent any disease. Individual results may vary.
            </p>
          </div>
          <div className="mt-10" data-id="element-607"></div>
        </div>
      </div>
    </>;
}